// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3idT9","element":"Home_element__251Rd"};